const es = {
  100000001:'Información clave',
  100000002:'Nombre del token',
  100000003:'Creador de la copia',
  100000004:'Tiempo de creación de la instancia',
  100000005:'Información básica  ',
  100000006:'Cadena de bloques/protocolo asociado  ',
  100000007:'Dirección del contrato inteligente  ',
  100000008:'Fecha de emisión',
  100000009:'Suministro total',
  100000010:'Suministro de circulación',
  100000011:'Valor de mercado',
  100000012:'Información',
  100000013:'Información de redes sociales',
  100000014:'Página web',
  100000015:'Libro blanco',
  100000016:'Explorador de blockchain  ',
  100000017:'Calificación del proyecto',
  100000018:'Ranking',
  100000019:'Top',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Hora de actualización',
  100000027:'Puntuación de seguridad  ',
  100000028:'Puntuación de seguridad del contrato  ',
  100000029:'Estadísticas de proyectos de riesgo  ',
  100000030:'Detalles del código del contrato  ',
  100000031:'Impuesto de compra  ',
  100000032:'Impuesto de venta  ',
  100000033:'Es un honeypot  ',
  100000034:'Se puede volver a mint  ',
  100000035:'Existe una lista negra  ',
  100000036:'Existe una lista blanca  ',
  100000037:'Es anti-ballenas  ',
  100000038:'Se puede cambiar la tasa impositiva  ',
  100000039:'Es de código abierto  ',
  100000040:'Existen titulares ocultos  ',
  100000041:'Se puede autodestruir  ',
  100000042:'Es un contrato proxy  ',
  100000043:'Se puede cambiar el saldo  ',
  100000044:'Se pueden ejecutar llamadas externas  ',
  100000045:'Se puede recuperar la propiedad  ',
  100000046:'Existe un período de enfriamiento para las transacciones  ',
  100000047:'Se pueden pausar las transferencias  ',
  100000048:'La propiedad no ha sido renunciada  ',
  100000049:'Es anti-ballenas ajustable  ',
  100000050:'Demasiados decimales  ',
  100000051:'Métodos públicos de Mint y Burn  ',
  100000052:'Quemar tokens actualiza el suministro total  ',
  100000053:'Quemar tokens actualiza el saldo    ',
  100000054:'Una transferencia a sí mismo aumenta el saldo    ',
  100000055:'Transferir más tokens de los que hay en el saldo será inválido  ',
  100000056:'El saldo no se actualiza durante la transferencia  ',
  100000057:'Se consumirá el saldo del receptor  ',
  100000058:'Llamar a TransferFrom superando el saldo fallará  ',
  100000059:'El método BurnFrom actualiza el suministro total  ',
  100000060:'Detectar el impuesto de compra del token. Más del 5% se considera una tasa de impuesto alta.',
  100000061:'Detectar el impuesto de venta del token. Más del 5% se considera una tasa de impuesto alta.',
  100000062:'Comprobar si el token es una estafa de tipo honeypot.',
  100000063:'Comprobar si se pueden acuñar más tokens.',
  100000064:'Comprobar si el token tiene una lista negra que puede restringir a los usuarios de intercambiar o transferir tokens.',
  100000065:'Comprobar si el token tiene una lista blanca que permite a las direcciones evitar cualquier restricción.',
  100000066:'Comprobar si el token tiene mecanismos anti ballena.',
  100000067:'Comprobar si el token tiene un impuesto y si este impuesto puede ser modificado por roles privilegiados.',
  100000068:'Comprobar si el token ha sido verificado en un explorador de blockchain.',
  100000069:'Comprobar si el token tiene un propietario oculto que puede manipular el contrato, incluso si la propiedad parece haber sido renunciada.',
  100000070:'Comprobar si el token puede autodestruirse.',
  100000071:'Comprobar si el token es un contrato proxy que delega llamadas de funciones a un contrato de implementación.',
  100000072:'Comprobar si el saldo del token puede ser modificado por roles privilegiados.',
  100000073:'Comprobar si el token llama a contratos externos.',
  100000074:'Comprobar si el token tiene una puerta trasera para recuperar la propiedad.',
  100000075:'Comprobar si el token tiene un mecanismo de enfriamiento de transferencias.',
  100000076:'Comprobar si el comercio del token puede ser pausado por roles privilegiados.',
  100000077:'Comprobar si se ha renunciado al privilegio del propietario.',
  100000078:'Comprobar si los mecanismos anti ballena del token pueden ser modificados por roles privilegiados.',
  100000079:'Comprobar si el valor devuelto por la función decimals() es mayor o igual a 5.',
  100000080:'Comprobar si llamar a las funciones mint() y burn() como usuarios aleatorios provocará un revert.',
  100000081:'Comprobar si llamar a la función burn() actualizará correctamente el totalSupply.',
  100000082:"Comprobar si llamar a la función burnFrom() actualizará correctamente la asignación.",
  100000083:'Comprobar si llamar a la función transfer() con el receptor igual al remitente de la transacción aumentará el saldo del remitente.',
  100000084:'Comprobar si llamar a la función transfer() con una cantidad mayor que el saldo fallará.',
  100000085:"Comprobar si la asignación del gastador se actualiza adecuadamente después de llamar a la función transferFrom().",
  100000086:"Comprobar si llamar a la función transferFrom() utilizará el saldo del gastador.",
  100000087:"Compruebe si la asignación se actualiza correctamente después de llamar a transferFrom(), o si la transacción se revierte si la cantidad es inválida.",
  100000088:"Compruebe si llamar a la función burnFrom() actualizará correctamente el totalSupply.",
  100000089:'Comprobar si existe autoridad para acuñar.',
  100000090:'Comprobar si existe autoridad para congelar.',
  100000091:'Revisar si los metadatos pueden ser cambiados.',
  100000092:'Crítico',
  100000093:'Mayor',
  100000094:'Medio',
  100000095:'Menor',
  100000096:'Informativo',
  100000097:'Se ha renunciado al permiso de mint  ',
  100000098:'Se ha renunciado al permiso de congelación  ',
  100000099:'Se pueden cambiar los metadatos del token  ',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default es


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/es.js